import { render, staticRenderFns } from "./credentialsUpload.vue?vue&type=template&id=12cbfcf4&scoped=true&"
import script from "./credentialsUpload.vue?vue&type=script&lang=js&"
export * from "./credentialsUpload.vue?vue&type=script&lang=js&"
import style0 from "./credentialsUpload.vue?vue&type=style&index=0&id=12cbfcf4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cbfcf4",
  null
  
)

export default component.exports